var _ellipse, _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.5,
    cy: 13.5,
    rx: 15.5,
    ry: 13.5,
    fill: "#F8C0BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3 13.8744V17.9989C19.3 18.3636 19.1694 18.7133 18.9368 18.9711C18.7043 19.2289 18.3889 19.3738 18.06 19.3738H11.24C10.9111 19.3738 10.5957 19.2289 10.3632 18.9711C10.1306 18.7133 10 18.3636 10 17.9989V10.4373C10 10.0727 10.1306 9.72301 10.3632 9.46518C10.5957 9.20735 10.9111 9.0625 11.24 9.0625H14.96",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4404 7H21.1604V11.1245",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3398 14.5615L21.1599 7",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.b9ce01f4.svg";
export { ForwardRef as ReactComponent };